Vue.component("sentiment-analysis-button", {
    props: ["params"],
    template: `
        <div class="dropdown">
            <div class="dropdown-select" @click="toggleTable">
                <span :class="{active: expanded}">{{ __('Category Performance') }}</span>
            </div>
        </div>
    `,
    data() {
        return {
            expanded: false
        };
    },
    methods: {
        toggleTable() {
            this.expanded = !this.expanded;
            this.$eventHub.$emit("toggleSentimentAnalysisTable", this.expanded);
        }
    }
});

Vue.component("sentiment-analysis-categories", {
    props: ["user", "teams", "selected_category"],
    data() {
        return {
            categories: {},
            keywords: {},
            averageScore: -1,
            params: {},
            expanded: false
        };
    },
    computed: {
        scoreClass() {
            if (this.averageScore >= 65) {
                return "success";
            } else if (this.averageScore >= 45) {
                return "warning";
            } else {
                return "danger";
            }
        },

        totalMentions() {
            let mentions = 0;

            for (category in this.categories) {
                mentions += this.categories[category].mentions;
            }

            return mentions;
        },
        cleanCategoryName() {
            let name = this.selected_category.replace("&", "n").toLowerCase();

            if (name.length == 0) {
                return "overall";
            } else {
                return name;
            }
        },
        firstKeywords() {
            let kw_counts = [];

            if (this.selected_category == "") {
                for (category in this.keywords) {
                    for (keyword in this.keywords[category]) {
                        kw_counts.push({
                            keyword: keyword,
                            category: category,
                            count: this.keywords[category][keyword]["count"]
                        });
                    }
                }
            } else {
                for (keyword in this.keywords[this.selected_category]) {
                    kw_counts.push({
                        keyword: keyword,
                        category: this.selected_category,
                        count: this.keywords[this.selected_category][keyword][
                            "count"
                        ]
                    });
                }
            }

            kw_counts.sort((a, b) =>
                a.count < b.count ? 1 : b.count < a.count ? -1 : 0
            );

            let run = kw_counts.length > 4 ? 4 : kw_counts.length;

            let fKws = {};

            for (i = 0; i < run; i++) {
                let current = kw_counts[i];
                fKws[current.keyword] = this.keywords[current.category][
                    current.keyword
                ];
            }

            return fKws;
        }
    },
    mounted() {
        let instance = this;

        this.$eventHub.$on(
            "toggleSentimentAnalysisTable",
            expanded => (instance.expanded = expanded)
        );

        this.$eventHub.$on("updateReviewQueryParams", params =>
            instance.updatePage(params)
        );
    },
    methods: {
        updatePage(params) {
            let ignore = [
                "sentimentCategory",
                "terms",
                "keyword",
                "positiveNegativeOrBoth"
            ];

            var params_string = Object.keys(params)
                .map(function(k) {
                    return params[k] == "" || ignore.includes(k)
                        ? ""
                        : encodeURIComponent(k) +
                              "=" +
                              encodeURIComponent(params[k]);
                })
                .join("&");

            axios
                .get(
                    "/api/terms/" +
                        Spark.state.currentTeam.id +
                        "/?" +
                        params_string
                )
                .then(response => {
                    this.categories = response.data.categories;
                    this.keywords = response.data.keywords;
                    this.averageScore = response.data.average_score;
                });
        },
        selectCategory(categoryName) {
            if (this.selected_category == categoryName) {
                return;
            }

            data = { terms: "", keyword: "" };

            if (categoryName != "overall") {
                data.sentimentCategory = categoryName;
            } else {
                // cancel category filter when overall is selected
                data.sentimentCategory = "";
            }

            this.$eventHub.$emit("applyFilters", data);
            // setTimeout(() => {
            //
            //     $('[data-toggle="popover"]').popover({
            //         html: true,
            //         trigger:'focus',
            //         content: function() {
            //             return $('#popover-content').html();
            //         }
            //     })
            // }, 500)
        }
    }
});

Vue.component("sentiment-analysis-category", {
    props: ["category", "category_name", "is_active"],
    template: `
        <div class="sentiment-analysis-category" :class="categoryClasses">
            <slot></slot>
        </div>
    `,
    data() {
        return {
            value: ""
        };
    },
    computed: {
        cleanName() {
            return this.category_name.replace("&", "n").toLowerCase();
        },
        categoryClasses() {
            let classes = "";

            classes += this.scoreClass;

            classes += " " + "sentiment-category-" + this.cleanName;

            if (this.is_active) {
                classes += " active";
            }

            return classes;
        },
        scoreClass() {
            if (this.category.score >= 65) {
                return "success";
            } else if (this.category.score >= 45) {
                return "warning";
            } else {
                return "danger";
            }
        }
    }
});

Vue.component("sentiment-point", {
    props: ["selected_category"],
    template: `
        <div>
            <div class="sentiment-point" :style="dynamicStyle">

            </div>
        </div>
    `,
    data() {
        return {
            is_ready: false
        };
    },
    mounted() {
        this.$eventHub.$on(
            "toggleSentimentAnalysisTable",
            val => (this.is_ready = true)
        );
    },
    computed: {
        dynamicStyle() {
            let label =
                this.selected_category == ""
                    ? "overall"
                    : this.selected_category;
            let elem = $(".sentiment-category-" + label).parent();

            let hello = this.is_ready;

            if (!elem.length) {
                return;
            }

            let position = elem.position();
            let height = elem.height();
            let width = elem.width();

            let style = {
                position: "absolute",
                // Add 5 extra pixels
                top: position.top + height + "px",
                left: position.left + width / 2 - 7 + "px"
            };

            style.display = "inline-block";

            return style;
        }
    }
});

Vue.component("sentiment-bubble", {
    props: ["selected_category", "selected_category_label"],
    template: `
    <div class="sentiment-bubble" ref="bubble" :style="dynamicStyle">
        <strong>{{ selected_category_label ? selected_category_label.toUpperCase() : 'OVERALL' }}</strong> | Keyword Breakdown
    </div>`,
    data() {
        return {
            is_ready: false
        };
    },
    mounted() {
        this.$eventHub.$on(
            "toggleSentimentAnalysisTable",
            val => (this.is_ready = true)
        );
    },
    computed: {
        dynamicStyle() {
            let label =
                this.selected_category == ""
                    ? "overall"
                    : this.selected_category;
            let elem = $(".sentiment-category-" + label).parent();

            let hello = this.is_ready;

            if (!elem.length) {
                return;
            }

            let position = elem.position();

            let width = $(".sentiment-bubble").width() / 2;
            let elemWidth = elem.width() / 2;
            let plusLeft = elemWidth - width;

            let leftValue = position.left + plusLeft - 14;

            if (leftValue < -15) {
                leftValue = -15;
            } else if (leftValue > 843) {
                leftValue = 843;
            }

            let style = {
                position: "absolute",
                left: leftValue + "px"
            };

            if (leftValue == -15) {
                style.borderTopLeftRadius = 0;
                style.borderBottomLeftRadius = 0;
            } else if (leftValue == 600) {
                style.borderTopRightRadius = 0;
                style.borderBottomRightRadius = 0;
            }

            style.display = "inline-block";

            return style;
        }
    }
});

Vue.component("do-the-dash", {
    props: ["selected_category"],
    template: `
    <div class="dash" :style="dynamicStyle">
        <svg viewBox="0 0 5 280" xmlns="http://www.w3.org/2000/svg">
            <line x1="3" y1="0" x2="3" y2="280" stroke="#017db9"
            stroke-dasharray="2" />
        </svg>
    </div>
    `,
    data() {
        return {
            is_ready: false
        };
    },
    mounted() {
        this.$eventHub.$on(
            "toggleSentimentAnalysisTable",
            val => (this.is_ready = true)
        );
    },
    computed: {
        dynamicStyle() {
            let label =
                this.selected_category == ""
                    ? "overall"
                    : this.selected_category;
            let elem = $(".sentiment-category-" + label).parent();

            let hello = this.is_ready;

            if (!elem.length) {
                return;
            }

            let position = elem.position();
            let height = elem.height();
            let width = elem.width();

            let h = label == "overall" ? "320px" : "40px";

            let style = {
                top: position.top + height + 16 + "px",
                left: position.left + width / 2 - 5 + "px",
                height: h
            };

            if (this.selected_category != "") {
                style.display = "inline-block";
            }

            return style;
        }
    }
});

Vue.component("sentiment-keyword", {
    props: ["keyword", "keyword_name"],
    template: `<slot></slot>`,
    computed: {
        scoreClass() {
            if (this.keyword.sentiment_score_avg >= 65) {
                return "success";
            } else if (this.keyword.sentiment_score_avg >= 45) {
                return "warning";
            } else {
                return "danger";
            }
        },

        positiveTerms() {
            let instance = this;

            var filtered = Object.keys(this.keyword.terms).reduce(function(
                positive,
                index
            ) {
                if (instance.keyword.terms[index].sentiment_score > 0) {
                    positive[index] = instance.keyword.terms[index];
                }

                return positive;
            },
            {});

            return filtered;
        },

        negativeTerms() {
            let instance = this;

            var filtered = Object.keys(this.keyword.terms).reduce(function(
                positive,
                index
            ) {
                if (instance.keyword.terms[index].sentiment_score < 0) {
                    positive[index] = instance.keyword.terms[index];
                }

                return positive;
            },
            {});

            return filtered;
        }
    },
    methods: {
        filterByKeyword(event) {
            event.preventDefault();
            // This also cancels any previous terms filter
            this.$eventHub.$emit("applyFilters", {
                keyword: this.keyword_name,
                terms: ""
            });
        },
        addTerm(event, term_name, term) {
            event.preventDefault();

            let term_str = term_name + ":" + this.keyword_name;
            data = { terms: term_str };

            this.$eventHub.$emit("applyFilters", data);
        },
        formatTerm(term) {
            if (term == "mentioned_positive") {
                return "Pos. Mention";
            }

            if (term == "mentioned_negative") {
                return "Neg. Mention";
            }

            return this.ucFirst(term);
        }
    }
});

// Vue.component('keyword-card', {

//     props: ['terms','keyword','positiveNegativeOrBoth','parentRefs'],

//     template: `
//         <div class="card-body bg-white border rounded terms-card" style="height: 100%;">

//             <span class="badge badge-pill"
//                 :class="'badge-' + sentimentColor(terms.sentiment_score_avg)">{{ terms.sentiment_score_avg }}</span>
//             <a href="#" @click="toggleKeyword($event)">
//                 {{ ucFirst(keyword) }}
//                 <span v-if="this.activeTermCount > 4 && this.view_remarks">(See <span v-show="this.expanded">less</span><span v-show="! this.expanded">more</span>)</span>
//             </a>
//             <span class="float-right" v-show="this.view_remarks"><a href="#" @click="clearKeywords($event)"><i class="fas fa-times"></i></a></span>
//             <div v-show="!this.view_remarks">
//                 <span v-show="this.activeTermCount <= 0">No remarks found</span>
//                 <a v-show="this.activeTermCount > 0" href="#" @click="addKeyword($event, keyword);">View {{ this.activeTermCount }}{{positiveNegativeOrBoth != 'both' ? ' '+positiveNegativeOrBoth : ''}} remark{{this.activeTermCount > 1 ? 's' : ''}} </a>
//             </div>

//             <div class="descriptive-terms mb-4" v-show="this.view_remarks" :class="{'expanded': this.expanded}">
//                 <br />
//                 <div class="positive-terms" v-show="positiveNegativeOrBoth != 'negative'">
//                     <p class="positiveNegativeLabel text-success" style="padid"><i class="fas fa-plus"></i> Positive</p>
//                     <ul class="p-0 terms-list">
//                         <li v-for="(term, term_name) in positiveTerms">{{ term_name }} (<a href="#" @click="addTerm($event, term_name, keyword)">{{ term.count }}</a> <i class="fas fa-comment"></i>)</li>
//                     </ul>
//                 </div>
//                 <div class="negative-terms" v-show="positiveNegativeOrBoth != 'positive'">
//                     <p class="positiveNegativeLabel text-danger"><i class="fas fa-minus"></i> Negative</p>
//                     <ul class="p-0 terms-list">
//                         <li v-for="(term, term_name) in negativeTerms">{{ term_name }} (<a href="#" @click="addTerm($event, term_name, keyword)">{{ term.count }}</a> <i class="fas fa-comment"></i>)</li>
//                     </ul>
//                 </div>
//             </div>
//         </div>
//     `,
//     mounted() {
//         this.$eventHub.$on('hide-remarks', (keyword) => {

//             if(this.keyword != keyword) this.view_remarks = false;

//         });
//     },
//     computed: {

//         negativeTerms() {

//             return this.onlyNegativeTerms(this.terms.terms);

//         },

//         positiveTerms() {

//             return this.onlyPositiveTerms(this.terms.terms);

//         },

//         positiveCount() {

//             return this.reduceAndAccumulate(this.positiveTerms,'count');

//         },

//         negativeCount() {

//             return this.reduceAndAccumulate(this.negativeTerms,'count');

//         },

//         activeTermCount() {
//             var total = 0;
//             if(this.positiveNegativeOrBoth != 'negative') total += this.positiveCount;
//             if(this.positiveNegativeOrBoth != 'positive') total += this.negativeCount;
//             return total;
//         }
//     },
//     data() {

//         return {

//             view_remarks: false,
//             expanded:false

//         }

//     },
//     methods: {

//         sentimentColor(sentiment_score) {

//             color = '';

//             if (sentiment_score >= 65) {

//                 color = 'success';

//             } else if (sentiment_score >= 50) {

//                 color = 'info';

//             } else if (sentiment_score >= 40) {

//                 color = 'warning';

//             } else {

//                 color = 'danger';

//             }

//             return color;

//         },

//         prevSlide(e) {

//             $('#terms-root').carousel('prev');

//         },

//         nextSlide(e) {

//             $('#terms-root').carousel('next');

//         },

//         scrollToReviews() {

//             window.scroll({
//                 behavior: 'smooth',
//                 left: 0,
//                 top: document.getElementById('all-reviews').getBoundingClientRect().top + window.pageYOffset
//             });

//         },

//         addTerm(e, term, keyword) {

//             //e.preventDefault();

//             this.eventHub.$emit('add-term',e, term, keyword);

//         },

//         addKeyword(e, keyword) {

//             this.view_remarks = true;
//             //e.preventDefault();
//             this.eventHub.$emit('add-keyword', e, keyword);

//         },

//         selectSentimentCategory(event, categoryName) {

//             event.preventDefault();
//             this.selectedSentimentCategory = categoryName;

//         },

//         clearKeywords(event) {

//             event.preventDefault();
//             this.view_remarks = false;
//             this.eventHub.$emit('clear-keywords', event);
//         },

//         onlyPositiveTerms(terms) {

// var filtered = Object.keys(terms).reduce(function(positive, index) {

//     if (terms[index].sentiment_score > 0) {

//         positive[index] = terms[index];

//     }

//     return positive;

// }, {});

// return filtered;

//         },

//         prevSlide(e) {

//             $('#terms-root').carousel('prev');

//         },

//         onlyNegativeTerms(terms) {

//             var filtered = Object.keys(terms).reduce(function(negative, index) {

//                 if (terms[index].sentiment_score < 0) {

//                     negative[index] = terms[index];

//                 }

//                 return negative;

//             }, {});

//             return filtered;

//         },

//         toggleKeyword(event) {

//             event.preventDefault();

//             if(this.view_remarks) this.expanded = !this.expanded;

//         },

//         reduceAndAccumulate(terms,field) {

//             return Object.keys(terms).map( key => terms[key][field] ).reduce(function(accumulator, currentValue, currentIndex, array) {

//                 return accumulator + currentValue;

//             },0);
//         }

//     }

// });

// Vue.component('descriptive-terms', {

// 	template: `
// 	<div id="descriptive-terms">
// 		<div class="row">
// 			<div class="col-lg-4 col-md-6 mb-2" v-for="(category, name) in semantic_analysis.categories">
// 				<div class="card-body border rounded" :class="'border-' + sentimentColor(category.score)">
// 			    	<h4 class="text-center mb-1">{{ name }}</h4>
// 			    	<hr class="mb-1 mt-1">
// 			    	<p class="text-center mb-1"><small>Score</small></p>
// 			    	<p class="text-center mb-1">
// 			    		<strong class="display-4 hotel-score" :class="'text-' + sentimentColor(category.score)">
// 			    			{{ category.score }}
// 		    			</strong>
// 	    			</p>
// 			    	<hr class="mb-1 mt-1">
// 			  		<p class="text-center mb-0">
// 			  			<a href="#" @click="selectSentimentCategory($event, name)">
// 			  				{{ category.mentions }} <i class="fas fa-comment"></i>
// 		  				</a>
// 	  				</p>
// 		    	</div>
// 			</div>
// 		</div>

// 		<div class="floating-tags">
// 			<input name="keywords" type="text" ref="keywords" value="" data-role="tagsinput">
// 			<input name="terms" type="text" ref="terms" value="" data-role="tagsinput">
// 		</div>
//         <div v-if="selectedSentimentCategory != ''" class="row mt-3 justify-content-center">

//             <button v-for="(displayName,status) in {'both':'All','positive':'Positive','negative':'Negative'}" class="btn" :class="positiveNegativeOrBoth==status ? 'btn-secondary' : 'btn-primary'" @click="positiveNegativeOrBoth=status;updateTerms()" v-html="displayName"></button>
//         </div>
// 		<div v-if="selectedSentimentCategory != ''" class="row mt-3">

// 			<div v-for="(terms, keyword) in semantic_analysis.keywords[selectedSentimentCategory]"
// 				class="col-lg-3 p-2">

//                 <keyword-card
//                     :terms=terms
//                     :keyword=keyword
//                     :positiveNegativeOrBoth=positiveNegativeOrBoth
//                     :sentiment_score_avg=terms.sentiment_score_avg
//                     :parentRefs=$refs
//                 ></keyword-card>

// 			</div>
// 		</div>

// 	</div>
// 	`,

// 	*
// 	<table class="table table-striped">
// 	  <tbody>
// 	    <tr v-for="(count, term) in terms.terms">
// 	      <td><a href="#" @click="addTerm($event, term, keyword)">{{ term }}</a></td>
// 	      <td><i class="fas fa-comment"></i> {{ count }}</td>
// 	    </tr>
// 	  </tbody>
// 	</table>

// 	data() {

// 		return {

// 			semantic_analysis: [],
//             params: {},
//             tags: [],
//             first: true,
//             activeChildTerms: [],
//             keyword: '',
//             selectedSentimentCategory: '',
//             expanded: [],
//             positiveNegativeOrBoth: 'both'

// 		}

//     },

//     computed: {

//     	isActive() {

//     		var result = this.first;
//     		this.first = false;

//     		return result;

//     	},

//         /**
//          * Filters keywords and returns the ones with more than 3 mentions
//          * and with a non-neutral sentiment score.
//          */
//         nonNeutralKeywords() {

//             var instance = this;

//             var filtered = Object.keys(this.semantic_analysis.keywords[this.selectedSentimentCategory]).reduce(function(p, c) {

//                 let item = instance.semantic_analysis.keywords[instance.selectedSentimentCategory][c];

//                 if (item.count > 3 && item.sentiment_score_avg != '-') {

//                     p[c] = item;

//                 }

//                 return p;

//             }, {});

//             return filtered;

//         }

//     },

//     mounted() {

//         $(this.$refs.terms).tagsinput({

// 	      allowDuplicates: false,
// 	      itemValue: 'id',  // this will be used to set id of tag
// 	      itemText: 'label' // this will be used to set text of tag

// 	    });

// 	    $(this.$refs.keywords).tagsinput({

// 	      allowDuplicates: false,
// 	      itemValue: 'id',  // this will be used to set id of tag
// 	      itemText: 'label' // this will be used to set text of tag

// 	    });

//         var instance = this;

//         $(this.$refs.terms).on('itemRemoved', function(e) {
//             if($(instance.$refs.terms).tagsinput('items').length <= 0) instance.eventHub.$emit('hide-remarks','');
//             instance.updateTerms();
//         });

// 	    $(this.$refs.keywords).on('itemRemoved', function(e) {
//             instance.clearKeyword();
//         });

// 	    $("#terms-root").on("slide.bs.carousel", function(e) {
// 		  var $e = $(e.relatedTarget);
// 		  var idx = $e.index();
// 		  var itemsPerSlide = 4;
// 		  var totalItems = $(".carousel-item").length;

// 		  if (idx >= totalItems - (itemsPerSlide - 1)) {
// 		    var it = itemsPerSlide - (totalItems - idx);
// 		    for (var i = 0; i < it; i++) {
// 		      // append slides to end
// 		      if (e.direction == "left") {
// 		        $(".carousel-item")
// 		          .eq(i)
// 		          .appendTo(".carousel-inner");
// 		      } else {
// 		        $(".carousel-item")
// 		          .eq(0)
// 		          .appendTo($(this).find(".carousel-inner"));
// 		      }
// 		    }
// 		  }
// 		});

// 	    $('#terms-root').carousel('pause');

//         this.$eventHub.$on('updateTermParams', (params) => {
//             this.updateTermParams(params);
//         });

//         this.$eventHub.$on('add-keyword', (e,keyword) => {
//             this.addKeyword(e,keyword);
//         });

//         this.$eventHub.$on('add-term', (e,term,keyword) => {
//             this.addTerm(e,term,keyword);
//         });

//         this.$eventHub.$on('clear-keywords', (e) => {
//             this.clearKeyword();
//         });

//     },

//     methods: {

//     	sentimentColor(sentiment_score) {

//     		color = '';

//     		if (sentiment_score >= 65) {

//     			color = 'success';

//     		} else if (sentiment_score >= 50) {

//     			color = 'info';

//     		} else if (sentiment_score >= 40) {

//     			color = 'warning';

//     		} else {

//     			color = 'danger';

//     		}

//     		return color;

//     	},

//         updateTermParams(params) {

//             this.params = params;
//             this.updatePage(params);

//         },

//     	updatePage(params) {

//             var params_string = Object.keys(params).map(function(k) {
//                 return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
//             }).join('&')

//             axios.get('/api/terms/' + Spark.state.currentTeam.id + "/?" + params_string)
//             .then(response => {

//                 this.semantic_analysis = response.data;

//             });

//         },
//         /**
//          * Filters terms and returns only positive ones
//          */
//         positiveTerms(terms) {

//             var filtered = Object.keys(terms).reduce(function(positive, index) {

//                 if (terms[index].sentiment_score > 0) {

//                     positive[index] = terms[index];

//                 }

//                 return positive;

//             }, {});

//             return filtered;

//         },

//         prevSlide(e) {

//             $('#terms-root').carousel('prev');

//         },

//         negativeTerms(terms) {

//             var filtered = Object.keys(terms).reduce(function(negative, index) {

//                 if (terms[index].sentiment_score < 0) {

//                     negative[index] = terms[index];

//                 }

//                 return negative;

//             }, {});

//             return filtered;

//         },

//         nextSlide(e) {

//         	$('#terms-root').carousel('next');

//         },

//         updateTerms() {

//         	// Possible bottleneck, beware
//         	var instance = this;

//         	this.tags = [];

//         	var el = this.$refs.terms;

//         	$(el).tagsinput('items').forEach(function(item) {

//         		instance.tags.push(item.label);

//         	});

//         	this.eventHub.$emit('filter-by-keyword', this.keyword, this.tags, this.positiveNegativeOrBoth, this.selectedSentimentCategory);

//         },

//         scrollToReviews() {

//             window.scroll({
//                 behavior: 'smooth',
//                 left: 0,
//                 top: document.getElementById('all-reviews').getBoundingClientRect().top + window.pageYOffset
//             });

//         },

//         addTerm(e, term, keyword) {

//             e.preventDefault();
//             this.clearKeyword(true);
//             this.scrollToReviews();

//         	var term_target = keyword + ':' + term;
//         	var term_id = term_target.replace(' ', '-');

//         	var el = this.$refs.terms;

//         	$(el).tagsinput('add', { id: term_id , label: term_target });

//         	this.updateTerms();

//         },

//         addKeyword(e, keyword) {

//             // Prevent scrolling to top.
//             e.preventDefault();
//             this.scrollToReviews();
//             this.eventHub.$emit('hide-remarks',keyword);
//             $(this.$refs.keywords).tagsinput('removeAll');

//             $(this.$refs.keywords).tagsinput('add', { id: keyword , label: keyword });
//             this.keyword = keyword;
//             //this.semantic_analysis.keywords[keyword].selected = true;
//             this.eventHub.$emit('filter-by-keyword', this.keyword, this.tags, this.positiveNegativeOrBoth, this.selectedSentimentCategory);

//         },

//         clearKeyword(showRemarks) {

//             //this.semantic_analysis.keywords[this.keyword].selected = false;
//             this.keyword = '';
//             $(this.$refs.terms).tagsinput('removeAll');
//             $(this.$refs.keywords).tagsinput('removeAll');
//             this.tags = [];
//             if(!showRemarks) this.eventHub.$emit('hide-remarks','');
//             this.eventHub.$emit('filter-by-keyword', '', this.tags, this.positiveNegativeOrBoth, this.selectedSentimentCategory);
//         },

//         /*clearFilter() {
//             this.keyword = '';
//             $(this.$refs.terms).tagsinput('removeAll');
//             this.tags = [];
//             this.eventHub.$emit('filter-by-keyword', '', this.tags, this.positiveNegativeOrBoth);
//         },*/

//         removeKeyword(event,keyword) {

//             if(this.keyword == keyword) {
//                 this.clearKeyword();

//             } else {
//             }

//         },

//         selectSentimentCategory(event, categoryName) {

//             event.preventDefault();
//             this.selectedSentimentCategory = categoryName;
//             this.eventHub.$emit('filter-by-keyword', '', this.tags, this.positiveNegativeOrBoth, this.selectedSentimentCategory);
//         },

//         toggleKeyword(event, keyword) {

//             event.preventDefault();

//         	if (this.expanded.includes(keyword)) {

//         		// remove keyword from expanded list
//         		this.expanded.splice(this.expanded.indexOf(keyword), 1);

//         	} else{

//         		this.expanded.push(keyword);

//         	}

//         }
//     }

// });
